export default function upper(s: string): string {
  return s.toLocaleUpperCase();
}
